export const shiftCardstyles = (theme) => {
    return {
        tagContainer: {
            backgroundColor: 'white',
            boxShadow: '0px 3px 6px #F7F9FC',
            border: '1px solid #E6EDF5',
            display: 'flex',
            marginTop: 2,
            marginLeft: 4,
            marginRight: 4,
            borderRadius: '5px 0px 0px 5px'
        },
        tagContainerPointer: {
            cursor: 'pointer'
        },
        divTagContainer: {
            padding: '3px 2px 3px 5px',
            marginRight: 4,
            textAlign: 'left',
            overflow: 'hidden',
            display: 'flex',
            width: '100%',
            flexFlow: 'row',
            alignItems: 'center',
            '& span': {
                overflow: 'hidden'
            }
        },
        tagContainerShift: {
            borderLeft: '4px solid #0A54A2'
        },
        tagContainerPaycode: {
            borderLeft: '4px solid #58cc5b',
            marginRight: 4
        },
        shiftName: {
            marginRight: 10
        },
        notes: {
            paddingLeft: 5
        },
        divTagContainerOpenshift: {
            // borderLeft: '4px solid #cc0000',
            background: '#cc0000',
            border: '2px solid #cc0000',
            borderRadius: '4px 0px 0px 4px',
            opacity: 1
        },
        divTagContainerPaycode: {
            // borderLeft: '4px solid #58cc5b',
            // marginRight: 4
            background: '#58cc5b',
            border: '2px solid #58cc5b',
            borderRadius: '4px 0px 0px 4px',
            opacity: 1,
            height: '34px'
        },
        divTagContainerShiftDouble: {
            borderLeft: '6px double #0A54A2',
        },
        divTagContainerOpenshiftDouble: {
            borderLeft: '6px double #cc0000',
        },
        divIcone: {
            textAlign: 'end',
            padding: '3px 3px 0px 0px'
        },
        divTagContainerBorder: {
            background: '#0a54a2',
            border: '2px solid #0a54a2',
            borderRadius: '4px 0px 0px 4px',
            opacity: 1
        }
    }
}